import { LabelChipV2, LabelChipV2Size, SxProps } from '@cast/design-system';

type Props = {
  sx?: SxProps;
  size?: LabelChipV2Size;
};

export const NewLabelChip = ({ sx, size = 's' }: Props) => (
  <LabelChipV2 label="New" color="indigo" size={size} sx={sx} />
);
